module.exports = "<div class=\"onBoardingDialog-bannerContainer\">\r\n    <!-- title message -->\r\n    <img class=\"onBoardingDialog-banner\" ng-src=\"{{$ctrl.bannerUrl}}\" />\r\n    <div class=\"onBoardingDialog-rewardsImageContainer\">\r\n    <img class=\"onBoardingDialog-rewardsImage\" ng-src=\"{{$ctrl.cardImage}}\" />\r\n    </div>\r\n\r\n</div>\r\n<div class=\"onBoardingDialog-titleContent\"><h2>{{ $ctrl.titleContent | sanitize}}</div>\r\n<div class=\"onBoardingDialog-textContent\"  ng-bind-html=\"$ctrl.textContent | sanitize\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/onboarding/onboarding-dialog-content.component.html
// module id = 365
// module chunks = 0 2